import { Component, Input, OnInit } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import domande from 'src/assets/domande.json';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
  width: string = '0%';
  widths: { [key: string]: string } = {};
  questions: any;
  sections: any = [];
  counts: { [key: string]: number } = {};
  constructor(private step: StepService) {}
  ngOnInit(): void {
    this.questions = domande;

    this.step.getWidth().subscribe((width) => {
      this.width = width;
    });

    this.countSection();
  }

  countSection() {
    this.questions.forEach((question: any) => {
      this.sections.push(question.sezione);
    });

    let total = 0;

    this.sections.forEach((section: any) => {
      this.counts[section] = (this.counts[section] || 0) + 1;
      total += 1;
    });

    for (let section in this.counts) {
      let proportion = (this.counts[section] / total) * 100;
      this.widths[section] = `${proportion.toFixed(2)}%`;
    }
    this.getCountsKeys();
  }

  getCountsKeys() {
    // console.log(Object.keys(this.counts));
    return Object.keys(this.counts);
  }
  getWidth(index: string): string {
    return this.widths[index];
  }
}
